/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */
import { Component } from '@angular/core';

@Component({
  selector: 'ptl-skeleton-pages-item',
  templateUrl: './skeleton-pages-item.component.html',
  styleUrls: ['./skeleton-pages-item.component.scss'],
})
export class SkeletonPagesItemComponent {}
